var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm.8 14.8H9.2v-1.5h1.6v1.5zm2.3-5.5c-.4.5-.9 1-1.4 1.4-.3.3-.5.6-.7.9-.1.4-.2.8-.1 1.2H9.2v-.6c0-.5.1-.9.3-1.4.3-.5.6-.9 1-1.2.3-.3.6-.5.9-.9.2-.2.2-.4.2-.7 0-.3-.2-.7-.4-.9-.3-.3-.7-.4-1.1-.4-.4.2-.8.3-1.2.6-.3.3-.5.7-.6 1.2l-1.6-.2c.1-.8.4-1.5 1-1.9.6-.6 1.5-.9 2.3-.9.9 0 1.8.2 2.5.8.6.5.9 1.1.9 1.9 0 .4-.1.8-.3 1.1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Help.svg